import { render, staticRenderFns } from "./DistributionPrimary.vue?vue&type=template&id=5fdb43e4"
import script from "./DistributionPrimary.vue?vue&type=script&lang=js"
export * from "./DistributionPrimary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports